import styled from 'styled-components';

export const Wrapper = styled('section')`
  margin-bottom: 35px;
  min-height: ${({ theme }) => theme.x4spacePx}px;
  position: relative;
  z-index: 1;
`;
